export function getPasswordPresentation(visible) {
  return visible
    ? { type: "text", label: "Скрыть пароль" }
    : { type: "password", label: "Показать пароль" };
}
